'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.convertToParams = convertToParams;
exports.parsePrice = parsePrice;
exports.convertToStates = convertToStates;
exports.find = find;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FILTERS = [{
  id: 'rate-5',
  type: 'rate'
}, {
  id: 'rate-4',
  type: 'rate'
}, {
  id: 'rate-3',
  type: 'rate'
}, {
  id: 'rate-2',
  type: 'rate'
}, {
  id: 'rate-1',
  type: 'rate'
}, {
  id: 'hotel-internet',
  type: 'hotelFacility'
}, {
  id: 'hotel-creditcard',
  type: 'hotelFacility'
}, {
  id: 'hotel-shuttle',
  type: 'hotelFacility'
}, {
  id: 'hotel-wheelchair',
  type: 'hotelFacility'
}, {
  id: 'room-internet',
  type: 'roomFacility'
}, {
  id: 'room-nonsmoking',
  type: 'roomFacility'
}, {
  id: 'room-smoking',
  type: 'roomFacility'
}, {
  id: 'room-washlet',
  type: 'roomFacility'
}, {
  id: 'meal-breakfast',
  type: 'meals'
}, {
  id: 'meal-dinner',
  type: 'meals'
}];

function convertToParams(_ref) {
  var filters = _ref.filters,
      priceRange = _ref.priceRange;

  var params = {};

  FILTERS.map(function (filter) {
    if (!params[filter.type]) {
      params[filter.type] = [];
    }
    var item = _lodash2.default.find(filters, { id: filter.id });
    if (item && item.checked) {
      params[filter.type].push(filter.id.split('-')[1]);
    }
    return filter;
  });

  return _lodash2.default.reduce(params, function (res, val, key) {
    return (0, _assign2.default)(res, (0, _defineProperty3.default)({}, key, val.join(',')));
  }, {
    price: priceRange && priceRange.low && priceRange.high ? '[' + priceRange.low + ',' + priceRange.high + ']' : ''
  });
}

function parsePrice(str) {
  var priceRange = {};
  if (str) {
    var matched = str.match(/\[(\d+(\.\d+)?),(\d+(\.\d+)?)\]/);
    if (matched) {
      priceRange.low = Number(matched[1]) || 1;
      priceRange.high = Number(matched[3]);
    }
  }
  return priceRange;
}

// TODO: the mapping from api to state
// const MAPPING = {
//   h_stars_1: 'rate-1',
//   h_stars_2: 'rate-2',
//   h_stars_3: 'rate-3',
//   h_stars_4: 'rate-4',
//   h_stars_5: 'rate-5',
//   h_net: 'hotel-internet',
//   h_card: 'hotel-creditcard',
//   h_bus: 'hotel-shuttle',
//   h_wheelchair: 'hotel-wheelchair',
//   r_net: 'room-internet',
//   r_nonsmoking: 'room-nonsmoking',
//   r_smoking: 'room-smoking',
//   r_toilet: 'room-washlet',
//   r_breakfast: 'meal-breakfast',
//   r_dinner: 'meal-dinner'
// };

function convertToStates(filters, params) {
  var states = [];

  FILTERS.forEach(function (filter) {
    var values = (params[filter.type] || '').split(',');
    var checked = false;
    if (values.length) {
      var value = values.indexOf(filter.id.split('-')[1]);
      checked = value !== -1;
    }
    states.push({
      id: filter.id,
      count: (_lodash2.default.find(filters, { id: filter.id }) || { count: 0 }).count,
      name: (_lodash2.default.find(filters, { id: filter.id }) || { name: '' }).name,
      checked: checked
    });
  });

  return states;
}

function find(type, items) {
  return _lodash2.default.filter(FILTERS, { type: type }).map(function (filter) {
    return _lodash2.default.find(items, { id: filter.id });
  }).filter(function (item) {
    return item;
  });
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/filters.js
// module id = 96
// module chunks = 0